import axios from 'axios';
import { API_BASE_URL } from './constant';



const api = axios.create({
  baseURL: API_BASE_URL,
});

api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Call Management API
export const getCalls = async () => {
  try {
    const response = await api.get('/calls');
    return response.data;
  } catch (error) {
    console.error('Error fetching calls:', error);
    throw error;
  }
};

// Call Logs API
export const getCallLogs = async () => {
  try {
    const response = await api.get('/calls/logs');
    return response.data;
  } catch (error) {
    console.error('Error fetching call logs:', error);
    throw error;
  }
};

// Device Management API
export const getDeviceQRCode = async () => {
  try {
    const response = await api.get('/devices/qr');
    return response.data;
  } catch (error) {
    console.error('Error fetching QR code:', error);
    throw error;
  }
};


// Service Payment API (matches backend: POST /service-payment/link)
export const createServicePayment = async ({ ticketId, serviceRef,amount,userName,isOffLine, phNumber }) => {
  try {
    const response = await api.post('/service-payment/link', {
      ticketId,
      serviceRef,
      userName,
      amount,
      isOffLine,
      phNumber
    });
    return response.data;
  } catch (error) {
    console.error('Error creating service payment:', error);
    throw error;
  }
};



// Fetch all service payments (POST /service-payment/list)
export const fetchAllServicePayments = async () => {
  try {
    const response = await api.post('/service-payment/list');
    return response.data;
  } catch (error) {
    console.error('Error fetching all service payments:', error);
    throw error;
  }
};


export async function fetchDashboardStats() {
  const response = await api.get('/dashboard/stats');
  if (!response.data.success) throw new Error('Failed to fetch stats');
  return response.data.data;
}




export const fetchServices = async () => {
  try {
    const response = await api.get('/services');
    return response.data;
  } catch (error) {
    console.error('Error fetching services:', error);
    throw error;
  }
};

// Get all page settings
export const getAllPageSettings = async () => {
  try {
    const response = await api.get('/page-settings');
    return response.data;
  } catch (error) {
    console.error('Error fetching page settings:', error);
    throw error;
  }
};

// Get one page setting by ID
export const getPageSettingById = async (id) => {
  try {
    const response = await api.get(`/page-settings/${id}`);
    return response.data;
  } catch (error) {
    console.error(`Error fetching page setting ${id}:`, error);
    throw error;
  }
};

// Create page setting
export const createPageSetting = async (data) => {
  try {
    const response = await api.post('/page-settings', data);
    return response.data;
  } catch (error) {
    console.error('Error creating page setting:', error);
    throw error;
  }
};

// Update page setting
export const updatePageSetting = async (id, data) => {
  try {
    const response = await api.put(`/page-settings/${id}`, data);
    return response.data;
  } catch (error) {
    console.error(`Error updating page setting ${id}:`, error);
    throw error;
  }
};

// Toggle active / inactive
export const togglePageSetting = async (id) => {
  try {
    const response = await api.put(`/page-settings/${id}/toggle`);
    return response.data;
  } catch (error) {
    console.error(`Error toggling page setting ${id}:`, error);
    throw error;
  }
};

// Delete (soft delete)
export const deletePageSetting = async (id) => {
  try {
    const response = await api.delete(`/page-settings/${id}`);
    return response.data;
  } catch (error) {
    console.error(`Error deleting page setting ${id}:`, error);
    throw error;
  }
};

// Done for the upload of document through interaction page 
// Document Upload API
export const uploadDocument = async (file, patientId, ticketId = null, threadId = null, description = '', sendViaWhatsApp = false) => {
  try {
    const formData = new FormData();
    formData.append('document', file);
    formData.append('patientId', patientId);
    if (ticketId) formData.append('ticketId', ticketId);
    if (threadId) formData.append('threadId', threadId);
    if (description) formData.append('description', description);
    formData.append('sendViaWhatsApp', sendViaWhatsApp);

    const response = await api.post('/documents/upload', formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
    return response.data;
  } catch (error) {
    console.error('Error uploading document:', error);
    throw error;
  }
};

// Get patient documents
export const getPatientDocuments = async (patientId) => {
  try {
    const response = await api.get(`/documents/patient/${patientId}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching patient documents:', error);
    throw error;
  }
};

// Send document via WhatsApp
export const sendDocumentViaWhatsApp = async (documentId) => {
  try {
    const response = await api.post(`/documents/${documentId}/send-whatsapp`);
    return response.data;
  } catch (error) {
    console.error('Error sending document via WhatsApp:', error);
    throw error;
  }
};

// Delete document
export const deleteDocument = async (documentId) => {
  try {
    const response = await api.delete(`/documents/${documentId}`);
    return response.data;
  } catch (error) {
    console.error('Error deleting document:', error);
    throw error;
  }
};

// Broadcast service request to vendors
export const broadcastServiceRequest = async (serviceRef, broadcastMessage, ticketId, patientRef) => {
  try {
    const response = await api.post('/reminders/broadcast', {
      serviceRef,
      broadcastMessage,
      ticketId,
      patientRef
    });
    return response.data;
  } catch (error) {
    console.error('Error broadcasting service request:', error);
    throw error;
  }
};

// Accept service request
export const acceptServiceRequest = async (broadcastId, ticketId, serviceRef) => {
  try {
    const response = await api.post('/reminders/accept-service', {
      broadcastId,
      ticketId,
      serviceRef
    });
    return response.data;
  } catch (error) {
    console.error('Error accepting service request:', error);
    throw error;
  }
};

// Reject service request
export const rejectServiceRequest = async (broadcastId) => {
  try {
    const response = await api.post('/reminders/reject-service', {
      broadcastId
    });
    return response.data;
  } catch (error) {
    console.error('Error rejecting service request:', error);
    throw error;
  }
};

export default api; 